var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "manage-messages",
      class: { "selected-messages-active": _vm.isSelectMode },
    },
    [
      _vm.isSelectMode
        ? _c("div", { staticClass: "manage-messages-info" }, [
            _c("div", { staticClass: "actions" }, [
              _c(
                "div",
                {
                  staticClass: "cancel-item",
                  attrs: { title: "Отменить выбор" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "button circle-animation",
                      on: { click: _vm.clearMessagesSelection },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
              _c("div", { staticClass: "selection-info" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("chat.selected-word")) +
                      ": " +
                      _vm._s(_vm.selectedMsgsNumber)
                  ),
                ]),
              ]),
              _c("div", { staticClass: "action-buttons" }, [
                _c(
                  "div",
                  {
                    staticClass: "button circle-animation",
                    style: _vm.isScheduledMsgs ? "margin-right: 4px;" : "",
                    attrs: { title: _vm.$t("chat.delete") },
                    on: { click: _vm.deleteMessages },
                  },
                  [_c("i", { staticClass: "fal fa-trash" })]
                ),
                !_vm.isScheduledMsgs
                  ? _c(
                      "div",
                      {
                        staticClass: "button circle-animation",
                        attrs: { title: _vm.$t("chat.copy") },
                        on: { click: _vm.copyMessages },
                      },
                      [_c("i", { staticClass: "fal fa-copy" })]
                    )
                  : _vm._e(),
                !_vm.isScheduledMsgs
                  ? _c(
                      "div",
                      {
                        staticClass: "button circle-animation",
                        attrs: { title: _vm.$t("chat.forward") },
                        on: { click: _vm.forwardMessages },
                      },
                      [_c("i", { staticClass: "fal fa-share" })]
                    )
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }